<template>
  <div>
    <select name="show" v-model="selectedResult">
      <option value="">Bitte ResultStatus auswählen</option>

      <option v-for="(val, i) in resultOptions" :value="val" :key="i">{{val}}</option>
    </select>

    <div id="popup-channel">
      <div id="popup-message-window">
        <a id="popup-message-close" v-on:click.prevent="closeOverlay">X</a>
        <div id="popup-message-content">
          <ParticipationResult  v-if="participationResult" :result="participationResult" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ParticipationResult from '@/components/ParticipationResult.vue'

export default {
  name: 'ParticipateResultTest',
  data: function() {
    return {
      selectedResult: "",
      results: {
          "sweep_participate": {
            "status":"success",
            "points_change":500,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "action":"go_to_landing_page",
            "campaign_type":"sweepstake/standard",
            "code":null,
            "current_points":37305,
            "sweep_point_cost":110,
            "campaign_main_type":"sweepstake",
            "ident":"d6e073d2-80a9-11ea-87e5-0242ac1c0004",
            "chance_user":3,
            "chance_total":14233,
          },
          "sweep_participate_again": {
            "status":"success",
            "points_change":-110,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"sweepstake/standard",
            "code":null,
            "current_points":37305,
            "sweep_point_cost":110,
            "campaign_main_type":"sweepstake",
            "ident":"d6e073d2-80a9-11ea-87e5-0242ac1c0004",
            "chance_user":4,
            "chance_total":14233,
          },
          "coupon_with_code_online_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 1
          },
          "coupon_with_code_online": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 0
          },
          "coupon_with_code_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 1
          },
          "coupon_no_code_online_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 1
          },
          "coupon_no_code_online": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 0
          },
          "coupon_no_code_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/percent",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 1
          },
          "coupon_free_show_merchant_instructions": {
            "status":"success",
            "points_change":300,
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "action":"show_merchant_instructions",
            "campaign_type":"coupon/free",
            "current_points":37305,
            "code":"dfgdfg234234",
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 0,
            coupon_redemption_via_merchant: 1,
            coupon_redemption_via_merchant_instructions:"Sobald ihre Anmeldedaten bei uns eingelangt sind, werden wir Ihnen Ihr Geschenk zuschicken.",
          },
          "coupon_free_show_merchant_instructions_with_landing_page": {
            "status":"success",
            "points_change":300,
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "action":"show_merchant_instructions",
            "campaign_type":"coupon/free",
            "current_points":37305,
            "code":"dfgdfg234234",
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 0,
            coupon_redemption_via_merchant: 1,
            coupon_redemption_via_merchant_instructions:"Sobald ihre Anmeldedaten bei uns eingelangt sind, werden wir Ihnen Ihr Geschenk zuschicken.",
            "landing_page":"http://example.com"
          },
          "coupon_free_with_code_online_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 1,
            coupon_redemption_via_merchant: 0,
          },
          "coupon_free_with_code_online": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 0,
            coupon_redemption_via_merchant: 0,
          },
          "coupon_free_with_code_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":"XFY2340sgdf",
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 1,
            coupon_redemption_via_merchant: 0,
          },
          "coupon_free_no_code_online_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 1,
            coupon_redemption_via_merchant: 0,
          },
          "coupon_free_no_code_online": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 1,
            coupon_redemption_offline: 0,
            coupon_redemption_via_merchant: 0,
          },
          "coupon_free_no_code_offline": {
            "status":"success",
            "points_change":300,
            "landing_page":"https://www.eltern-letsfamily-de.de",
            "campaign_ident":"fc270b79-9a6b-4f34-9431-0431485daa84",
            "campaign_type":"coupon/free",
            "code":null,
            "current_points":37305,
            "campaign_main_type":"coupon",
            coupon_redemption_online: 0,
            coupon_redemption_offline: 1,
            coupon_redemption_via_merchant: 0,
          },
      }
    }
  },
  computed: {
    participationResult(){
      if (this.selectedResult !== "") {
        window.scrollTo(0,0);
        document.body.classList.add('formularContent');
        document.getElementById("popup-message-background").classList.add('active');
        return this.results[this.selectedResult];
      }
      return null;
    },
    resultOptions() {
      return Object.keys(this.results);
    }
  },
  methods: {
    closeOverlay() {
      document.body.classList.remove('formularContent');
      document.getElementById("popup-message-background").classList.remove('active');
      this.showOverlay = false;
      window.location = window.location.pathname;
    }
  },
  components: {
    ParticipationResult
  },
}
</script>
